import type { ButtonHTMLAttributes } from 'react'
import React from 'react'

import { Box } from '@gousto-internal/citrus-react'
import { useMedia } from 'react-use'

import * as trackingKeys from 'actions/trackingKeys'
import { useIsBasketComprehensionEnabled } from 'routes/Menu/hooks/useIsBasketComprehensionEnabled'
import { DESKTOP_VIEW, MOBILE_VIEW } from 'utils/view'

import { BrowseCTAContainer } from '../BrowseCTA'
import { BrowseCTAButtonContainer } from '../BrowseCTAButton'
import { BasketComprehensionBanner } from './BasketComprehensionBanner'
import { CheckoutButton } from './CheckoutButton'
import { ExpandBoxSummaryButton } from './ExpandBoxSummaryButton'
import { OpenBoxButton } from './OpenBoxButton'
import { PriceAndDiscountTip } from './PriceAndDiscountTip'

import css from './BoxSummaryBanner.css'

type Props = {
  numRecipes: number
  onExpandClick: ButtonHTMLAttributes<Element>['onClick']
  showBrowseCTA: boolean
}

export const BoxSummaryBanner = ({ numRecipes, onExpandClick, showBrowseCTA }: Props) => {
  const isToMedium = useMedia(css.BreakpointToMedium)
  const isBasketComprehensionEnabled = useIsBasketComprehensionEnabled()
  const view = isToMedium ? MOBILE_VIEW : DESKTOP_VIEW

  if (isBasketComprehensionEnabled) {
    return <BasketComprehensionBanner showBrowseCTA={showBrowseCTA} view={view} />
  }

  return (
    <section>
      <div
        className={css.boxSummaryBanner}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...(isToMedium ? { onClick: onExpandClick } : {})}
      >
        {isToMedium ? (
          <div>
            <OpenBoxButton />
          </div>
        ) : null}
        <div className={css.buttonsContainer} data-no-code="boxSummaryPriceContainer">
          {isToMedium ? (
            <PriceAndDiscountTip numRecipes={numRecipes} />
          ) : (
            <ExpandBoxSummaryButton
              onClick={onExpandClick || (() => {})}
              numRecipes={numRecipes}
              showBrowseCTA={showBrowseCTA}
            />
          )}

          {showBrowseCTA ? (
            <>
              <BrowseCTAButtonContainer view={view} />
              <BrowseCTAContainer view={view} />
            </>
          ) : (
            <>
              <Box width="1rem" />
              <CheckoutButton view={view} section={trackingKeys.menu} />
            </>
          )}
        </div>
      </div>
    </section>
  )
}
